import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import {
  MatTableDataSource,
  MatTableDataSourcePageEvent,
} from '@angular/material/table';
import { Router } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { Solicitud } from 'src/app/administracion/modelos/Control_Usuario/solicitud';
import { UsuarioService } from 'src/app/administracion/servicios';
import { ServicioUsuarioService } from 'src/app/administracion/servicios/Control_Usuario/servicio-usuario.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-seguimiento-asignacion-servicio',
  templateUrl: './seguimiento-asignacion-servicio.component.html',
  styleUrls: ['./seguimiento-asignacion-servicio.component.scss'],
})
export class SeguimientoAsignacionServicioComponent implements OnInit {
  dataSource = new MatTableDataSource<Solicitud>([]);
  /* Paginators */
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  expression = false;

  encabezadostabla: String[] = [
    'descargarResp',
    'subirResp',
    'nomColaborador',
    'nomPuesto',
    'name_sucursalCol',
    'status_solicitud',
    'fechaRegistro',
    'fechaSolicitud',
  ];

  opcionesPaginacion = {
    pagina: 0,
    cantidad: 10,
  };
  totalElementos = 0;
  data: Solicitud[] = [];

  cargando = false;
  idSolicitudSubiendoResponsiva = 0;

  buscar = '';

  constructor(
    private router: Router,
    private servicioUsuarioService: ServicioUsuarioService,
    private usuarioService: UsuarioService
  ) {
    // this.llenarListas();
  }

  ngOnInit(): void {
    // this.llenarTablaSeg();
    this.llenarTablaSolicitudes();
    //this.capturarParametro();
  }

  /**Llena la lista de empleados */
  /*llenarListas() {
    this.usuarioService.getAllEmpleados().subscribe((val) => {
      this.listaEmpleados = val;
    });
  } */

  /**Metodo para llenar la tabla de datos */
  llenarTablaSeg() {
    this.expression = true;
    let listaSolicitudes: Solicitud[] = [];

    this.servicioUsuarioService
      .todosLosServiciosUsuarioPaginacion(
        this.opcionesPaginacion.pagina,
        this.opcionesPaginacion.cantidad
      )
      .subscribe(
        (servicios) => {
          this.totalElementos = servicios.total;

          servicios.data.forEach((servicio) => {
            this.expression = false;
            let valor = listaSolicitudes.find(
              (element) =>
                element.id_solicitud ==
                servicio.detalleSolicitud.solicitud.id_solicitud
            );
            if (valor == undefined) {
              this.expression = false;
              /**Creamos el objeto solicitud para agregarle todos los datos para despues añadirlo al arreglo de la tabla */
              let solicitud: Solicitud = new Solicitud();
              solicitud.id_solicitud =
                servicio.detalleSolicitud.solicitud.id_solicitud;
              this.usuarioService
                .getAnEmpleado(
                  Number(servicio.detalleSolicitud.solicitud.colaboradorId)
                )
                .subscribe((val) => {
                  solicitud.name_colaborador_id =
                    val?.nombre +
                    ' ' +
                    val?.apellidoPat +
                    ' ' +
                    val?.apellidoMat;
                  solicitud.name_cargo_colaborador = val?.puesto?.nombrePuesto;
                  solicitud.name_sucursalCol = val?.sucursal?.nombreSucursal;
                });
              solicitud.fechaSolicitud =
                servicio.detalleSolicitud.solicitud.fechaSolicitud?.substring(
                  0,
                  10
                );
              solicitud.fecha_planeada_act = servicio.fechaRegistro?.substring(
                0,
                10
              );
              solicitud.status_solicitud =
                servicio.detalleSolicitud.solicitud.status_solicitud;
              listaSolicitudes.push(solicitud);
              // this.dataSource.paginator = this.paginator;
              this.expression = false;
            }
            this.expression = false;
          });
          this.dataSource.data = listaSolicitudes;
        },
        (err) => {
          this.expression = false;
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error de conexión',
            text: 'Lo sentimos las solicitudes no se cargaron correctamente debido a que no hay conexión con el servidor, por favor  inténtelo más tarde.',
          });
        }
      );
  }

  llenarTablaSolicitudes() {
    this.expression = true;
    let listaSolicitudes: Solicitud[] = [];

    this.servicioUsuarioService
      .todosLasSolicitudesPaginacion(
        this.opcionesPaginacion.pagina,
        this.opcionesPaginacion.cantidad,
        this.buscar
      )
      .subscribe(
        (solicitudes) => {
          this.expression = false;
          this.totalElementos = solicitudes.total;
          this.dataSource.data = [];

          solicitudes.data.forEach((solicitud) => {
            this.usuarioService
              .getAnEmpleado(Number(solicitud.colaboradorId))
              .subscribe((val) => {
                solicitud.name_colaborador_id =
                  val?.nombre + ' ' + val?.apellidoPat + ' ' + val?.apellidoMat;
                solicitud.name_cargo_colaborador = val?.puesto?.nombrePuesto;
                solicitud.name_sucursalCol = val?.sucursal?.nombreSucursal;
              });
            solicitud.fechaSolicitud = solicitud.fechaSolicitud?.substring(
              0,
              10
            );
            solicitud.fecha_planeada_act =
              solicitud.fecha_planeada_act?.substring(0, 10);

            listaSolicitudes.push(solicitud);
            // this.dataSource.paginator = this.paginator;
          });
          this.dataSource.data = listaSolicitudes;
        },
        (err) => {
          this.expression = false;
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error de conexión',
            text: 'Lo sentimos las solicitudes no se cargaron correctamente debido a que no hay conexión con el servidor, por favor  inténtelo más tarde.',
          });
        }
      );
  }

  paginar(event: MatTableDataSourcePageEvent) {
    this.opcionesPaginacion.pagina = event.pageIndex;
    this.opcionesPaginacion.cantidad = event.pageSize;
    // this.llenarTablaSeg();
    this.llenarTablaSolicitudes();
  }

  /**Método para filtrar los datos de ala tabla por lo que ingresa el usuario */
  applyFilter(event: string) {
    this.opcionesPaginacion.pagina = 0;
    this.buscar = event.trim().toUpperCase();
    this.llenarTablaSolicitudes();
  }

  /**Crea una ventana para poder subir la responsiva */
  async subirResponsiva(idSolicitud: number) {
    const { value: file } = await Swal.fire({
      title: 'Selecciona el PDF de la responsiva firmada',
      input: 'file',
      inputAttributes: {
        accept: '.pdf',
        'aria-label': 'Subir responsiva',
      },
    });

    /**Valida que se haya subido un archivo */
    if (!file) {
      return;
    }

    /**Valida que el archivo subido sea un pdf/ Segunda validación de refuerzo */
    if (file.type !== 'application/pdf') {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'El archivo no es un PDF',
        text: 'Lo sentimos, el archivo que intenta subir no corresponde a un formato PDF ',
      });
      return;
    }

    /**Valida que el peso del archivo no sea superior al permitido 1048576 bytes*/
    if (file.size >= 4194304) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Tamaño de archivo no permitido',
        text: 'El archivo que intenta subir supera el tamaño permitido, por favor verifique su documento.',
      });
      return;
    }

    this.idSolicitudSubiendoResponsiva = idSolicitud;
    this.cargando = true;
    this.expression = true;

    const reader = new FileReader();
    this.servicioUsuarioService
      .todosLosServiciosUsuarioPorSolicitudId(idSolicitud)
      .subscribe((servicios) => {
        console.log(servicios);

        const listObservables: Observable<any>[] = [];
        servicios.forEach((servicio) => {
          listObservables.push(
            this.servicioUsuarioService.cargarResponsivaCarrpeta(
              Number(servicio.id_servicio_usuario),
              file
            )
          );
        });

        forkJoin(listObservables).subscribe(
          () => {
            reader.readAsDataURL(file);
            this.cargando = false;
            this.expression = false;
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Archivo subido',
              text: 'La responsiva ha sido guardada correctamente ',
            });
            this.llenarTablaSolicitudes();
          },
          (err) => {
            console.log(err);
            this.cargando = false;
            this.expression = false;
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'Cargar responsiva',
              text: 'La responsiva no se cargó correctamente debido a un problema con el servidor, por favor inténtelo más tarde o contacte al área de T.I. ',
            });
            this.llenarTablaSolicitudes();
          }
        );
      });
  }

  /**Redirecciona a la vista en donde deberá elegir el que suscribe la resonsiva para despues descargarla  */
  descargarResponsiva(idSolicitud: number) {
    this.router.navigate(['layout/ResponsivaServicio/' + idSolicitud]);
  }
}
